import React from 'react'
import Button from 'components/button'
import Tooltip from 'components/tooltip'
import { Triangle } from 'components/icons'

interface DataTablePaginationProps {
  pageIndex: number
  pageSize: number
  /** Rows across every page: those left after the search and filters. */
  rowCount: number
  onPrevious: () => void
  onNext: () => void
}

/**
 * Under a table with more rows than a page, at the right of its foot: which rows are showing, of how many,
 * and a button either side to turn the page, in the manner of shadcn/ui's data table pagination.
 */
const DataTablePagination: React.FC<DataTablePaginationProps> = ({
  pageIndex,
  pageSize,
  rowCount,
  onPrevious,
  onNext
}) => {
  const first = pageIndex * pageSize + 1
  const last = Math.min(rowCount, (pageIndex + 1) * pageSize)
  return (
    <nav aria-label="Pages" className="ml-auto flex items-center gap-3">
      <span className="text-[13px] text-body tabular-nums">
        {first}–{last} of {rowCount}
      </span>
      <div className="flex items-center gap-1">
        <Tooltip content="Previous page">
          <Button
            internalType="outline"
            aria-label="Previous page"
            className="size-8 p-0"
            disabled={pageIndex === 0}
            onClick={onPrevious}
          >
            <Triangle type="left" />
          </Button>
        </Tooltip>
        <Tooltip content="Next page">
          <Button
            internalType="outline"
            aria-label="Next page"
            className="size-8 p-0"
            disabled={last >= rowCount}
            onClick={onNext}
          >
            <Triangle type="right" />
          </Button>
        </Tooltip>
      </div>
    </nav>
  )
}

export default DataTablePagination
